import React from "react";
import { Divider } from "../components/UI/divider";
import { Subheading } from "../components/UI/heading";
import MenuEditor from "../components/MenuEditor/MenuEditor";

export default function MenuEditorPage() {
  return (
    <>
      <Subheading>Me 'N' U</Subheading>
      <Divider className="my-6" />
      <MenuEditor />
    </>
  );
}
